/**
 * PromptCard 拼装与 token 估算工具
 * - 子句分组：subject/action/environment | composition/lighting/camera | color/medium/style/mood | quality
 * - 组内用「，」、组间用「。」
 * - token 估算：CJK ≈ 1.5 / char，ASCII 字母数字 ≈ 0.3 / char，其它（标点/空格）≈ 0.5 / char
 */

import type { PromptFields } from '../../utils/canvas-api'

export const CLAUSE_GROUPS: Array<Array<keyof Required<PromptFields>>> = [
  ['subject', 'action', 'environment'],
  ['composition', 'lighting', 'camera'],
  ['color', 'medium', 'style', 'mood'],
  ['quality'],
]

export function assemblePreview(fields: Required<PromptFields>): string {
  const clauses = CLAUSE_GROUPS.map((group) =>
    group
      .map((k) => (fields[k] ?? '').trim())
      .filter((v) => v.length > 0)
      .join('，'),
  ).filter((c) => c.length > 0)

  return clauses.join('。')
}

const CJK_RE = /[一-鿿぀-ヿ가-힯]/
const ALNUM_RE = /[A-Za-z0-9]/

export function estimateTokens(text: string): number {
  if (!text) return 0
  let sum = 0
  for (const ch of text) {
    if (CJK_RE.test(ch)) sum += 1.5
    else if (ALNUM_RE.test(ch)) sum += 0.3
    else sum += 0.5
  }
  return Math.ceil(sum)
}

export const TOKEN_RECOMMEND_MAX = 77
